import { useState, useCallback } from 'react';

export type Errors<Keys extends string | number | symbol>  = {
  [Property in Keys]?: string;
};
export type setErrors<Keys extends string | number | symbol> = React.Dispatch<React.SetStateAction<Errors<Keys>>>;
export type SetErrors<Keys extends string | number | symbol> = setErrors<Keys>;
export type TResetError = (e?: React.ChangeEvent<HTMLInputElement> | null, fieldName?: string) => void;
export type ResetErrorField = TResetError;

const useErrors = <Keys extends string | number>(defaultErrors: Errors<Keys>  = {}) => {
  const [errors, setErrors] = useState<Errors<Keys>>(() => defaultErrors);

  const resetErrorsField: ResetErrorField = useCallback((event, fieldName) => {
    const target = event && event.target as HTMLInputElement;
    const name = fieldName as Keys || target?.name as Keys;
    if (name) {
      setErrors((prevErrors) => {
        const prevErrorsCopy = { ...prevErrors };
        delete prevErrorsCopy[name];
        return prevErrorsCopy;
      });
    }
  }, [setErrors]);

  return [errors, setErrors, resetErrorsField] as const;
};

export default useErrors;